import { isEpochCastType } from '../utils/isEpochCastType';
import { useCastTypeState, useConditionState } from '../../../../../hooks/condition';
import { CastType, DefaultComparator } from '../../../../../types';

export const useOnCastTypeChange = (onChange: (castType: CastType | null) => void) => {
  const { setCondition } = useConditionState();
  const { castType } = useCastTypeState();
  /** on cast type we want to reset the value input and value */
  return (newCastType: CastType | null) => {
    if (!(isEpochCastType(castType) && isEpochCastType(newCastType)))
      setCondition((condition) => ({
        ...condition,
        value: undefined,
        comparatorType: DefaultComparator.EQUALS,
      }));
    onChange(newCastType);
  };
};
